import { render, staticRenderFns } from "./DesignPaperSample.vue?vue&type=template&id=55f1f19f&scoped=true&"
import script from "./DesignPaperSample.vue?vue&type=script&lang=js&"
export * from "./DesignPaperSample.vue?vue&type=script&lang=js&"
import style0 from "./DesignPaperSample.vue?vue&type=style&index=0&id=55f1f19f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f1f19f",
  null
  
)

export default component.exports